import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getAnalytics } from 'firebase/analytics';

const firebaseConfig = {
  apiKey: "AIzaSyBNIiNPMuJ86bavYWP7aPNDPvkkji4U6-o",
  authDomain: "firmaiprotocols.firebaseapp.com",
  projectId: "firmaiprotocols",
  storageBucket: "firmaiprotocols.firebasestorage.app",
  messagingSenderId: "220325003501",
  appId: "1:220325003501:web:a4762145eace75734a4ce4",
  measurementId: "G-HH44KX4Q8P"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const analytics = getAnalytics(app);

export { app, auth, analytics };
